<template>
  <div class="right-chart-1">
    <div class="rc1-chart-container">
      <dv-scroll-board :config="config" style="width:100%;height:100%;" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'RightChart2',
  props: {
    partsnumber: Array
  },
  data() {
    return {
      config: {
        header:["零件编号", "零件名称", "加工数量"],
        data: [
          ['2','5522缸盖', '5'],
          ['1','模具1', '2'],
          ['2','模具2', '3'],
          ['3','缸体', '1'],
          ['2','曲轴', '8'],
          ['1','连接器', '10'],
        ],
        index:true,
        headerBGC:"#3333ff",
        columnWidth: [50],
        align: ['center']
      }
    }
  },
  watch: {
    'qty': function (newVal) {
      this.update(0, newVal);
    },
    'total': function (newVal) {
      this.update(1, newVal);
    }, 'planStop': function (newVal) {
      this.update(2, newVal);
    },
    'realTime': function (newVal) {
      this.update(3, newVal);
    },
    'qualifiedRatio': function (newVal) {
      this.update(4, newVal);
    }
  },
  methods: {
    update(index, value) {
      this.$data.config.data[index].value = value;

      this.$data.config = { ...this.$data.config }
    }
  },
  watch: {
    'partsnumber' : function(newVal){
         this.config.data.splice(0,this.config.data.length);
         [...this.config.data] = this.partsnumber;
         this.$data.config = {...this.$data.config}     
      },
  }
}
</script>

<style lang="less">
.right-chart-1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rc1-header {
    font-size: 24px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }

  .rc1-chart-container {
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }

  .left {
    width: 15%;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 34px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .right {
    flex: 1;
    padding-bottom: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
</style>
